import React, {useState} from "react";
import addOrRemoveFromCart from "../addOrRemoveFromCart";
const numeral = require('numeral');

export default ({item}) => {

    const [quantity, setQuantity] = useState(item.quantity);
    const [initQuantity, setInitQuantity] = useState(item.quantity);
    const [dirty, setDirty] = useState(100);

    const updateFromOrder = (order) =>
    {
        for (const i of order.items) {
            if (item.id === i.id) {
                setInitQuantity(i.quantity);
                let d = dirty;
                if (dirty === 200) {
                    if (i.quantity === quantity) {
                        d = 300
                    }
                }
                setDirty(d);
            }
        }
    }

    return <ul className="order-item">
        <li>
            <h4>Product code</h4>
            <p>{item.product_sku}</p>
        </li>
        <li>
            <h4>Product Name</h4>
            <p>{item.product_title}</p>
        </li>
        <li>
            <h4>Qty. Available</h4>
            <p>{item.product_available_qty}</p>
        </li>
        <li>
            <h4>Price</h4>
            <p>{numeral(item.total).format('$0.00')} EXCL GST</p>
        </li>
        <li>
            <h4>Quantity</h4>
            <div className="cart-count-align">

                <input type="number"
                       value={quantity}
                       onChange={(e) => {
                           const input = e.target;
                           let value = parseInt(input.value);
                           if (value > item.product_available_qty) {
                               value = item.product_available_qty;
                           }
                           if (value < 0) {
                               value = 0;
                           }
                           setQuantity(value);
                           setDirty(value !== initQuantity ? 200 : 100);
                       }} />
                <a onClick={(e) => {
                    e.preventDefault();
                    addOrRemoveFromCart(item.product_id, quantity, (order) => {
                        updateFromOrder(order)
                    });
                    return false;
                }} className={dirty === 200 ? 'btn' : 'btn btn--blue--border'}>
                    {dirty === 300 ? 'Updated' : 'Update cart'}
                </a>
            </div>
        </li>
    </ul>

}
